// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var State;
(function (State) {
    State["ACTIVE"] = "ACTIVE";
    State["PROMOTE"] = "PROMOTE";
    State["HIDE"] = "HIDE";
})(State || (State = {}));
export var State_index;
(function (State_index) {
    State_index[State_index["ACTIVE"] = 0] = "ACTIVE";
    State_index[State_index["PROMOTE"] = 1] = "PROMOTE";
    State_index[State_index["HIDE"] = 2] = "HIDE";
})(State_index || (State_index = {}));
// DisplayFeaturesType is used to display the corresponding Marketing Name and conditional aestricks in the UI as per the below sheet
//ref: https://docs.google.com/spreadsheets/d/1G6pF-POs6MIltWYjo0I6imJy2BSNIwKP67cjx9GHSpk/edit?usp=sharing 
export var DisplayFeatureType;
(function (DisplayFeatureType) {
    DisplayFeatureType["DEFAULT"] = "DEFAULT";
    DisplayFeatureType["MARKETING"] = "MARKETING";
    DisplayFeatureType["INTEGRATED"] = "INTEGRATED";
    DisplayFeatureType["PHONE"] = "PHONE";
})(DisplayFeatureType || (DisplayFeatureType = {}));
export var DisplayFeatureType_index;
(function (DisplayFeatureType_index) {
    DisplayFeatureType_index[DisplayFeatureType_index["DEFAULT"] = 0] = "DEFAULT";
    DisplayFeatureType_index[DisplayFeatureType_index["MARKETING"] = 1] = "MARKETING";
    DisplayFeatureType_index[DisplayFeatureType_index["INTEGRATED"] = 2] = "INTEGRATED";
    DisplayFeatureType_index[DisplayFeatureType_index["PHONE"] = 3] = "PHONE";
})(DisplayFeatureType_index || (DisplayFeatureType_index = {}));
export var PackageType;
(function (PackageType) {
    PackageType["PACKAGE_DEFAULT"] = "PACKAGE_DEFAULT";
    PackageType["PHONES"] = "PHONES";
    PackageType["SOFTWARE_ONLY"] = "SOFTWARE_ONLY";
})(PackageType || (PackageType = {}));
export var PackageType_index;
(function (PackageType_index) {
    PackageType_index[PackageType_index["PACKAGE_DEFAULT"] = 0] = "PACKAGE_DEFAULT";
    PackageType_index[PackageType_index["PHONES"] = 1] = "PHONES";
    PackageType_index[PackageType_index["SOFTWARE_ONLY"] = 2] = "SOFTWARE_ONLY";
})(PackageType_index || (PackageType_index = {}));
export var AddOn;
(function (AddOn) {
    AddOn["ADDON_DEFAULT"] = "ADDON_DEFAULT";
    AddOn["WEAVE_FORMS"] = "WEAVE_FORMS";
    AddOn["ONLINE_SCHEDULING"] = "ONLINE_SCHEDULING";
})(AddOn || (AddOn = {}));
export var AddOn_index;
(function (AddOn_index) {
    AddOn_index[AddOn_index["ADDON_DEFAULT"] = 0] = "ADDON_DEFAULT";
    AddOn_index[AddOn_index["WEAVE_FORMS"] = 1] = "WEAVE_FORMS";
    AddOn_index[AddOn_index["ONLINE_SCHEDULING"] = 2] = "ONLINE_SCHEDULING";
})(AddOn_index || (AddOn_index = {}));
export const PackageService = {
    GetActiveCustomizationFlagsBySFBundle(fn, req) {
        return fn(`/package-service/v1/customizationflags?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetSalesforceBundleName(fn, req) {
        return fn(`/package-service/v1/salesforce-bundle-name?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetPlanDetails(fn, req) {
        return fn(`/package-service/v1/plan-details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetPlanComparisonDetails(fn, req) {
        return fn(`/package-service/v1/plan-comparison-details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Set the demo location customizations on the basis of the location_id, bundle, vertical, packages and addons and also update the location vertical
    SetDemoLocationCustomizations(fn, req) {
        return fn(`/package-service/v1/demo/customizations`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetSalesforceBundleNameForMulti(fn, req) {
        return fn(`/package-service/v1/multi/salesforce-bundle-name?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
